import type { CareStateLabOrderT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { PATIENT_LAB_ORDERS_TAB_ID } from '@/features/patient-workspace/model/tabIds';
import { toTableSearchText } from '@/shared/lib/table';

import type { PatientGlobalSearchHit } from '../types';

function parseDateMs(value: unknown): number | null {
  if (typeof value !== 'string' || value.trim() === '') {
    return null;
  }
  const next = new Date(value).getTime();
  return Number.isFinite(next) ? next : null;
}

export function toLabOrderSearchHits(
  labOrders: readonly CareStateLabOrderT[]
): PatientGlobalSearchHit[] {
  return labOrders.map((order) => {
    const testName = toTableSearchText(order.order_data.value.lab_test.name).trim();
    const markers = order.order_data.value.lab_test.markers.map((marker) => marker.name).join(' ');
    const status = toTableSearchText(order.status).trim();
    const interpretation = toTableSearchText(order.interpretation).trim();
    const orderedAt = toTableSearchText(order.ordered_at).trim();
    const subtitleParts = ['Ordered through Lotus Health', status, orderedAt].filter(
      (part) => part !== ''
    );

    return {
      id: `care-state:lab-orders:${order.id}`,
      resource: 'care-state:lab-orders',
      tabId: PATIENT_LAB_ORDERS_TAB_ID,
      title: testName || 'Lab order',
      subtitle: subtitleParts.join(' · '),
      keywords: [testName, status, interpretation, markers].filter((part) => part !== '').join(' '),
      sortTimestampMs: parseDateMs(order.ordered_at),
      resultId: order.id,
    };
  });
}
